export const ON_MOUNT = 'ON_MOUNT'
export const ON_RESIZE = 'ON_RESIZE'
export const ON_SCROLL_RIGHT = 'ON_SCROLL_RIGHT'
export const ON_SCROLL_LEFT = 'ON_SCROLL_LEFT'
export const ON_TAB_SELECTION = 'ON_TAB_SELECTION'
